/**
 * Role-aware routes for the Live Sessions 4-step create wizard.
 */

export type RolePrefix = '/admin' | '/trainer';

export type LiveSessionCreateRoutes = {
  /** Step 1 — session details */
  createSession: string;
  /** Step 2 — prepare / curriculum */
  prepareSession: string;
  /** Step 3 — topic planner */
  topicPlanner: string;
  /** Step 3 side-path — question bank */
  questionBank: string;
  /** Step 4 — duration confirm + API create */
  scheduleSession: string;
  /** Success exit — View Sessions list */
  viewSessions: string;
  /** Alias used by schedule page (maps to view sessions) */
  plannedSessions: string;
  assignSessions: string;
};

/** @deprecated use LiveSessionCreateRoutes */
export type CodeliveCreateRoutes = LiveSessionCreateRoutes;

export function getRolePrefix(pathname?: string): RolePrefix {
  const path =
    pathname ||
    (typeof window !== 'undefined' ? window.location.pathname : '/admin');
  return path.startsWith('/trainer') ? '/trainer' : '/admin';
}

export function getCreateRoutes(pathname?: string): LiveSessionCreateRoutes {
  const prefix = getRolePrefix(pathname);
  const base = `${prefix}/create-session`;
  const viewSessions = `${prefix}/view-sessions`;
  return {
    createSession: base,
    prepareSession: `${base}/prepare`,
    topicPlanner: `${base}/planner`,
    questionBank: `${base}/planner/question-bank`,
    scheduleSession: `${base}/schedule`,
    viewSessions,
    plannedSessions: viewSessions,
    assignSessions: `${prefix}/assign-sessions`,
  };
}

/** Lazy role-aware accessors — call `getCreateRoutes()` once per property read. */
export const ROUTES: LiveSessionCreateRoutes = {
  get createSession() {
    return getCreateRoutes().createSession;
  },
  get prepareSession() {
    return getCreateRoutes().prepareSession;
  },
  get topicPlanner() {
    return getCreateRoutes().topicPlanner;
  },
  get questionBank() {
    return getCreateRoutes().questionBank;
  },
  get scheduleSession() {
    return getCreateRoutes().scheduleSession;
  },
  get viewSessions() {
    return getCreateRoutes().viewSessions;
  },
  get plannedSessions() {
    return getCreateRoutes().plannedSessions;
  },
  get assignSessions() {
    return getCreateRoutes().assignSessions;
  },
};
